import { warn } from "@ember/debug";
import { isTesting } from "@embroider/macros";
import ControlTower from "wise-control-tower";

export default function logError(error: Error, id: string) {
  if (isTesting()) return;
  const errMsg = `Detected error "${id}" with description:\n\n${error}`;
  warn(errMsg, { id: id });
  ControlTower.captureMessage(errMsg);
}
